<template>
  <div class="white_bg">
    <div class="bindStudent">
      <div class="top">
        <div class="boxd">
          <img
            :src="logo"
            alt
          />
        </div>
        <img
          src="../../assets/qRCode/hbj.png"
          alt
          style="width: 212px; margin-left: 30px"
        />
      </div>
      <div class="companyname">
        {{ sponsor ? sponsor : "北京博思致新互联网科技有限责任公司" }}
      </div>
      <div class="center">
        <van-form>
          <div v-if="!needSyncField">
            <div
              class="fieldBox"
              v-if="needTicketTip == 'true'"
            >
              <img
                src="../../assets/img/paymentUnit.png"
                alt
              />
              <van-field
                v-model="payInfo.paymentUnit"
                placeholder="请输入单位或个人名称"
              />
            </div>

            <div
              class="fieldBox"
              v-if="needTicketTip == 'true'"
            >
              <img
                src="../../assets/img/wxphone.png"
                alt
              />
              <van-field
                maxlength="11"
                type="number"
                v-model="payInfo.phone"
                :placeholder="'请输入手机号码'"
              />
            </div>
            <div
              v-if="needShowItem"
              class="fieldBox"
            >
              <img
                class="self_qr_pic"
                src="../../assets/img/qrcode_icon.png"
                alt=""
              />
              <van-field
                right-icon="arrow"
                readonly
                v-model="payInfo.itemName"
                :placeholder="'请选择收费项目'"
                @click="openPicker1"
              />
            </div>
            <div class="fieldBox">
              <img
                class="self_qr_pic"
                src="../../assets/img/qr_je.png"
                alt
              />
              <van-field
                v-model="payInfo.payAmt"
                :max='999999999.99'
                type='number'
                readonly
                @click="openKeyBoard"
                :placeholder="'请输入缴费金额(元)'"
              />
            </div>
            <div
              class="fieldBox"
              v-if="showRemark"
            >
              <img
                class="self_qr_pic"
                src="../../assets/img/qr_bz.png"
                alt
              />
              <van-field
                maxlength="50"
                v-model="payInfo.remark"
                :placeholder="'请输入付款备注'"
              />
            </div>
          </div>
          <div v-if="needSyncField">
            <div
              class="fieldBox"
              v-for="(item, index) in addData"
              :key="index"
              v-show="item.fieldName!='remark'"
            >
              <img
                v-if="item.fieldName == 'paymentUnit'"
                src="../../assets/img/paymentUnit.png"
                alt
              />
              <img
                v-else-if="item.fieldName == 'phone'"
                src="../../assets/img/wxphone.png"
                alt
              />
              <img
                class="self_qr_pic"
                v-else
                src="../../assets/img/qrcode_icon.png"
                alt
              />
              <div>
                <van-field
                  v-if="item.fieldType == '0'&&item.fieldName!='remark'"
                  v-model="payInfo[item.fieldName]"
                  :placeholder="`请输入`+item.showName"
                />
              </div>

              <div>
                <van-field
                  v-if="item.fieldType == '1'"
                  v-model="payInfo[item.fieldName]"
                  type="digit"
                  :placeholder="`请输入` + item.showName"
                />
              </div>
              <div>
                <van-field
                  v-if="item.fieldType == '5'"
                  v-model="payInfo[item.fieldName]"
                  type="number"
                  :placeholder="`请输入` + item.showName"
                />
              </div>
              <div v-if="
                  item.fieldType == '2' ||
                  item.fieldType == '7' ||
                  item.fieldType == '6'
                ">
                <van-field
                  @click="openPicker(item)"
                  :placeholder="`请选择` + item.showName"
                  readonly
                  right-icon="arrow"
                  :value="selectVaueObj[item.fieldName]"
                >
                </van-field>
                <van-popup
                  v-model="showPicker"
                  position="bottom"
                >
                  <van-picker
                    ref="van_picker"
                    value-key="label"
                    show-toolbar
                    :columns="columns"
                    @confirm="confirmPicker"
                    @cancel="showPicker = false"
                    :default-index="defaultIndex"
                  />
                </van-popup>
              </div>

              <div v-if="item.fieldType == '3'">
                <van-field
                  @click="openDate(item)"
                  right-icon="arrow"
                  input-align="left"
                  readonly
                  :placeholder="`请选择` + item.showName"
                  :value="selectVaueObj[item.fieldName]"
                >
                </van-field>
                <van-calendar
                  v-model="showDate"
                  color="#1989fa"
                  @confirm="onConfirmDate"
                  :default-date="defaultDate"
                  :min-date="minDate"
                  :max-date="maxDateCom"
                />
              </div>
              <div v-if="item.fieldType == '4'">
                <van-field
                  right-icon="arrow"
                  @click="openDateTime(item)"
                  :placeholder="`请选择` + item.showName"
                  input-align="left"
                  readonly
                  :value="selectVaueObj[item.fieldName]"
                >
                </van-field>
                <van-popup
                  v-if="item.fieldType == '4'"
                  v-model="showDateTimePicker"
                  position="bottom"
                >
                  <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    title="选择完整时间"
                    :min-date="minDate"
                    :max-date="maxDateCom"
                    @confirm="onConfirmDateTime()"
                    @cancel="showDateTimePicker = false"
                  />
                </van-popup>
              </div>
              <div v-if="item.fieldType == '9'">
                <!-- 年月 -->
                <van-field
                  readonly
                  clickable
                  right-icon="arrow"
                  :placeholder="`请选择` + item.showName"
                  input-align="left"
                  :value="selectVaueObj[item.fieldName]"
                  @click="hanldeShowMonth(item)"
                />
                <van-popup
                  v-if="item.fieldType == '9'"
                  v-model="showMonthPicker"
                  position="bottom"
                >
                  <van-datetime-picker
                    v-model="currentDate"
                    type="year-month"
                    title="选择年月"
                    :max-date="maxDateCom"
                    @confirm="onConfirmMonth()"
                    @cancel="showMonthPicker = false"
                  />
                </van-popup>
              </div>

              <div v-if="item.fieldType == '8'">
                <van-field
                  v-model="uploadName[item.fieldName]"
                  :name="item.fieldName"
                  readonly
                  input-align="left"
                  @click="openFieldDialog(item)"
                  :placeholder="`点击上传` + item.showName"
                />
              </div>
              <div v-if="item.fieldType == '10'">
                <van-field
                    v-model="payInfo[item.fieldName + 'show']"
                    :name="item.fieldName"
                    :placeholder="'请选择' + item.showName"
                    @click="cascadeChange(item)"
                />
              </div>
            </div>

            <div
              v-if="needShowItem"
              class="fieldBox"
            >
              <img
                class="self_qr_pic"
                src="../../assets/img/qrcode_icon.png"
                alt=""
              />
              <van-field
                right-icon="arrow"
                readonly
                v-model="payInfo.itemName"
                :placeholder="'请选择收费项目'"
                @click="openPicker1"
              />
            </div>
            <div class="fieldBox">
              <img
                class="self_qr_pic"
                src="../../assets/img/qr_je.png"
                alt
              />
              <van-field
                v-model="payInfo.payAmt"
                readonly
                type='number'
                :max='999999999.99'
                @click="openKeyBoard"
                :placeholder="'请输入缴费金额(元)'"
              />
            </div>
            <div
              class="fieldBox"
              v-for="(item, index) in addData"
              :key="item.fieldName"
              v-show="item.fieldName=='remark'"
            >
              <img
                class="self_qr_pic"
                src="../../assets/img/qr_bz.png"
                alt
              />
              <van-field
                maxlength="50"
                v-model="payInfo.remark"
                :placeholder="'请输入'+item.showName"
              />
            </div>
            <!-- <div
                v-if="item.showName != '验证码' && item.showName != '备注'"
                class="fieldBox"
                :key="index"
              >
                <img
                  v-if="item.fieldName == 'paymentUnit'"
                  src="../../assets/img/paymentUnit.png"
                  alt=""
                />
                <img
                  v-else-if="item.fieldName == 'idCard'"
                  src="../../assets/img/iconCard.png"
                  alt=""
                />
                <img
                  v-else-if="item.fieldName == 'phone'"
                  src="../../assets/img/wxphone.png"
                  alt=""
                />
                <img v-else src="../../assets/img/kzpic.png" alt="" />
                <van-field
                  v-model="queryInfo[item.fieldName]"
                  :name="item.showName"
                  :placeholder="'请输入' + item.showName"
                />
              </div> -->
          </div>
        </van-form>

        <div style="margin-bottom: 22px; text-align: center">
          <van-button
            block
            type="info"
            :disabled="disabledBtn"
            @click="handlePay"
            native-type="submit"
            class="bindBtn"
          >
            确认支付
            <img
              class="blueSha"
              src="../../assets/img/blueshadow.png"
              alt
            />
          </van-button>
        </div>
        <div
          class="pri"
          v-if="(!needSyncField && needTicketTip == 'true') || needSyncField"
        >
          <van-checkbox
            v-model="isRead"
            shape="square"
            label-disabled
          >
            <span @click="isRead = !isRead">勾选即代表我已阅读并同意</span>
            <span @click="toNotice">《用户隐私政策》</span>
          </van-checkbox>
        </div>
        <!-- color更多字体颜色 -->
        <!-- state使用什么颜色的喇叭 1-绿色  2-蓝色 -->

      </div>
    </div>
    <CustomFoot
      :typeName="'10'"
      :isHome="true"
      class="zdyfooter"
      color="#297bf4"
      state="2"
    >
      <div class="btn_shadow notice_box_foot">
        确认
        <span></span>
      </div>
    </CustomFoot>
    <van-number-keyboard
      :show="show"
      v-model="payInfo.payAmt"
      theme="custom"
      type="number"
      extra-key="."
      close-button-text="完成"
      @close="handleConfirm"
      @blur="judgeMax"
    />
    <div id="widget" />
    <UploadDialog
      :showDialog="showUploadDialog"
      :selectField="selectRow"
      :deptId="payInfo.deptId"
      @close="closeUpload"
      :selectFiled="uploadFiledsObj[selectRow.fieldName]"
    ></UploadDialog>
    <!-- 专门用于收费项目的弹出层 -->
    <van-popup
      v-model="showPicker1"
      position="bottom"
    >
      <!-- <van-search placeholder="请输入收款二维码名称" v-model="searchName" @input="getPositionList"/>  value-key="roadName"-->
      <van-picker
        ref="van_picker_item"
        cancel-button-text="取消"
        show-toolbar
        :columns="items"
        @confirm="confirmItem"
        @cancel="showPicker1 = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import Head from "@/components/head";
import Foot from "@/components/foot";
import {
  isEmpty,
  formatterSureDate,
  formatterDate,
  savePrivacy,
} from "../../utils/common";
import SearchPicker from "@/components/searchPicker";
import UploadDialog from "@/components/uploadDialog.vue";
import PrivacyDialog from "@/components/dialog/privacyDialog";
import CustomFoot from "@/components/customFoot";

let loadedMineMapJs = false;
export default {
  components: {
    Head,
    Foot,
    SearchPicker,
    UploadDialog,
    PrivacyDialog,
    CustomFoot,
  },
  data() {
    return {
      // 当前最大日期
      maxDateCom: new Date(),
      showPicker1: false,
      // readContent:"0",
      checkRead: false,
      show: false,
      needSyncField: false, //跟随单位配置展示字段
      needShowItem: false, //是否需要显示收费项目
      payInfo: {
        payAmt: "",
        paymentUnit: "",
        phone: "",
        deptId: "",
        roadCode: "",
        remark: "",
        itemId: "",
        deviceType: "phone",
      },
      selectVaueObj: {},
      vde: "",
      logo: "",
      list: [],
      items: [], //收费项目数据
      itemName: "",
      itemDisable: false,
      itemPicker: false,
      maxlength: 6,
      disabledBtn: true,
      needTicketTip: "", //true时，添加提示信息
      isMust: false,
      showRemark: true,
      bgImg: require("@/assets/img/beijing.png"),
      addData: [],

      showPicker: false,
      defaultIndex: 0,
      showDate: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2030, 10, 1),
      maxNow: new Date(),
      defaultDate: new Date(),
      showDateTimePicker: false,
      currentDate: "",

      columns: [],
      selectRow: {},
      editAmt: true, //金额是否可编辑

      showUploadDialog: false,
      uploadName: {}, //上传时输入框显示的名字
      uploadFiledsObj: {},
      isRead: false,
      details: [],
      showMonthPicker: false,
      sponsor: "",
    };
  },
  watch: {
    "payInfo.payAmt": {
      handler(val) {
        if (val.indexOf(".") != -1) {
          let arr = val.split(".");
          if (arr.length == 2) {
            this.maxlength = arr[0].length + 3;
            if (arr[1].length > 2) {
              this.payInfo.payAmt = arr[0] + "." + arr[1].substring(0, 2);
            }
          } else {
            this.payInfo.payAmt = arr[0] + "." + arr[1];
          }
        } else {
          this.maxlength = 6;
        }
        if (val > 0) {
          this.disabledBtn = false;
        } else {
          this.disabledBtn = true;
        }
        // 如果第一个字符为.
        if (val[0] == ".") {
          this.payInfo.payAmt = "0" + val;
        }
        // 如果小数点前面开头连续两个0
        if (val[0] == "0" && val[1] == "0") {
          this.payInfo.payAmt = "0";
          // 如果开头第一个为0，第二个不为.
        }
        if (val[0] == "0" && val[1] > 0) {
          this.payInfo.payAmt = val[1];
        }
      },
    },
  },
  created() {
    this.vde = this.$route.query.vde ? this.$route.query.vde : "";
    this.payInfo.deptId = this.$route.query.deptId
      ? this.$route.query.deptId
      : "";
    this.payInfo.roadCode = this.$route.query.roadCode
      ? this.$route.query.roadCode
      : "";
    this.needTicketTip = this.$route.query.needTicketTip
      ? this.$route.query.needTicketTip
      : "";
    localStorage.setItem("sysType", "2");
    localStorage.setItem("scene", "2");
    this.init();
    this.getHeadImg();
    this.getFootData();
    this.getShowConfigs();
  },
  activated() {
    // console.log(this.$route.query?.isRead);
    let state = this.$route.query?.isRead;
    this.isRead = state === 1 ? true : false;
    if (this.isRead) {
      // this.handlePay();
    }
    localStorage.setItem("sysType", "2");
    localStorage.setItem("scene", "2");
    let obj = JSON.parse(localStorage.getItem('addInfo'))
    if(obj) {
      this.payInfo = {
        ...this.payInfo,
        ...obj
      }
      localStorage.removeItem('addInfo')
    }
  },
  methods: {
    cascadeChange(item) {
      this.$router.push({
        path: '/login/cascadeTree',
        query: {
          uId: item.dictionary,
          dictId: this.payInfo[item.fieldName],
          dictName: this.payInfo[item.fieldShowName],
          fieldName: item.fieldName,
          fieldShowName: item.fieldShowName,
        }
      })
    },
    judgeMax() {
      this.show = false;
      if (this.payInfo.payAmt >= 999999999.99) {
        this.payInfo.payAmt = "999999999.99";
      }
    },
    hanldeShowMonth(item) {
      this.selectRow = item;
      this.showMonthPicker = true;
      if (item.allowFutureDate) {
        this.maxDateCom = this.maxNow;
      } else {
        this.maxDateCom = this.maxDate;
      }
      if (this.payInfo[item.fieldName]) {
        this.currentDate = new Date(this.payInfo[item.fieldName]);
      } else {
        this.currentDate = new Date();
      }
    },
    // 月份点击确定
    onConfirmMonth() {
      let year = this.currentDate.getFullYear();
      let month = this.currentDate.getMonth() + 1;
      if (month <= 9) {
        month = "0" + month;
      }
      this.payInfo[this.selectRow.fieldName] = `${year}-${month}`;
      this.selectVaueObj[this.selectRow.fieldName] = `${year}-${month}`;
      this.showMonthPicker = false;
    },
    toNotice() {
      this.$router.push({
        path: "/parking/notice",
        query: {
          person: "1",
          headerText: "通知",
          params: JSON.stringify(this.$route.query),
        },
      });
    },
    goNextAction(isRead, details, type) {
      this.isRead = isRead;
      this.details = details;
      if (type == 1) {
        this.handlePay();
      }
    },
    // 勾选隐私
    getReadState(isRead, details, type) {
      this.isRead = isRead;
      this.details = details;
    },
    init() {
      if (this.needTicketTip == "true") {
        this.$CDialog({
          confirmBtnText: "是", //按钮文字
          title: "提示", //title提示文字
          message: "是否录入个人信息用于开票，是则必须填写缴款人及手机号码！", //弹窗内容
          status: "2", //显示哪种图   1 为绿色   2为蓝色
          textSize: "14", // 字体大小，默认12
          cancelBtnText: "否",
        })
          .then((res) => {
            this.isMust = true;

            //点击确定之后的处理
          })
          .catch((rs) => {
            this.isMust = false;
          });
        // Dialog.confirm({
        //   title: "提示",
        //   message: "是否录入个人信息用于开票，是则必须填写缴款人及手机号码！",
        //   confirmButtonText: "是",
        //   cancelButtonText: "否",
        // })
        //   .then(() => {
        //     this.isMust = true;
        //   })
        //   .catch(() => {
        //     this.isMust = false;
        //   });
      }
    },
    getHeadImg() {
      let data = {};
      data.vde = this.vde;
      this.request({
        url: "/webPortal/websitConfig",
        method: "get",
        params: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          if (res.data.result == null) {
            this.logo = require("@/assets/img/logo.png");
            return;
          }
          if (res.data.result.logoUrl) {
            this.logo = res.data.result.logoUrl;
          } else {
            this.logo = require("@/assets/img/logo.png");
          }
          if (res.data.result && res.data.result.websitTitle) {
            document.title = res.data.result.websitTitle;
            sessionStorage.setItem("title", res.data.result.websitTitle);
          } else {
            document.title = "欢迎使用政付通缴费平台";
          }
          if (res.data.result.logoName) {
            this.sponsor = res.data.result.logoName;
          }
          sessionStorage.setItem("title", res.data.result.websitTitle);
          document.title = sessionStorage.getItem("title");
        } else if (res.data.code != 1000) {
          this.$router.push({ path: "/404" });
        }
      });
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 10,
      };
      this.request({
        url: "/systemManage/mobileGetMessage",
        method: "get",
        params: data,
      }).then((res) => {
        if ((res.data.code = 1000)) {
          this.list = res.data.result;
          // this.readContent=res.data.result.readContent
          if (this.list.bgurl) {
            this.bgImg = this.list.bgurl;
          }
        }
      });
    },
    // 搜索条件处理 ------------------------start
    getDictionaryData(url, data) {
      return this.request({
        url: url,
        method: "get",
        params: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          return res.data.result;
        }
      });
    },
    // 获取年份数组
    getYearArray(field) {
      const date = new Date();
      let currentYear;
      if (field.allowFutureDate) {
        currentYear = date.getFullYear();
      } else {
        currentYear = date.getFullYear() + 10;
      }
      const yearArray = [];
      // 入学年度，最多录入当年的
      const lastYear = currentYear;
      for (let i = lastYear; i >= 1900; i--) {
        let obj = {
          value: i.toString(),
          label: i.toString(),
        };
        yearArray.push(obj);
      }
      return yearArray;
    },
    // 获取路段配置信息
    getShowConfigs() {
      return new Promise((resolve) => {
        this.request({
          url: "/sysRoadData/getShowConfigs",
          method: "get",
          params: {
            roadCode: this.payInfo.roadCode,
            deptId: this.payInfo.deptId,
          },
        }).then((res) => {
          if (res.data && res.data.code == 1000) {
            let result = res.data.result;
            if (result.isNeedSyncField) {
              this.getAddData();
            }
            this.needSyncField = result.isNeedSyncField; //
            this.needShowItem = result.isNeedShowItem;
            this.items = result.items;
            this.items.forEach((item) => {
              item.text = item.itemName;
            });
            if (this.items.length == 1) {
              this.confirmItem(this.items[0]);
              this.itemDisable == true;
            }
          } else {
            // this.$CDialog({
            // confirmBtnText: "确认",
            // title: "提示",
            // status: "2",
            // textSize: 14,
            // message: res.data.message,
            // }).then((res) => {});
            let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                textSize: 14,
                message: res.data.message,
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false,
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                textSize: 14,
                message: res.data.message,
              });
            }
          }
          resolve();
        });
      });
    },
    // 获取查询条件
    getAddData() {
      return new Promise((resolve) => {
        this.request({
          url: "/busFieldConfig/listBusFieldConfigedNoAuth",
          method: "get",
          params: {
            applicableScene: 2,
            deptId: this.payInfo.deptId,
          },
        }).then((res) => {
          if (res.data && res.data.code == 1000) {
            this.addData = res.data.result;
            this.addData.forEach((item) => {
              if ((item.fieldType == 2 || item.fieldType== 7) &&item.dictionary) {
                let url;
                let data;
                if (item.fieldType == "2") {
                  url = "/system/dictionary/listDictData/" + item.dictionary;
                } else if (item.fieldType == "7") {
                  url = "/system/dictDeptData/listDictDeptData";
                  data = {
                    deptId: this.payInfo.deptId,
                    dictType: item.dictionary,
                  };
                }
                this.getDictionaryData(url, data).then((result) => {
                  this.$set(item, "options", result);
                  if (item.defaultValue) {
                    this.payInfo[item.fieldName] = item.defaultValue;
                    result.forEach((val) => {
                      if (val.value == item.defaultValue) {
                        this.$set(
                          this.selectVaueObj,
                          item.fieldName,
                          val.label
                        );
                      }
                    });
                  }
                });
              }
              if(item.fieldType == 10){
                item.fieldShowName = item.fieldName+'show'
                this.request({
                  url: '/deptCascadeDictData/listDeptCascadeDictDataTree',
                  params: {
                    dictId:item.dictionary
                  }
                }).then(res => {
                  let data = this.flattenTree(res.data.result)
                  data.map(it => {
                    if(it.uId == item.defaultValue){
                      console.log( it.dictName)
                      this.payInfo[item.fieldName] = it.uId
                      this.payInfo[item.fieldName + 'show'] = it.dictName
                    }

                  })
                  this.$forceUpdate()
                  console.log(this.payInfo)
                })
              }
              if (item.fieldType == "6") {
                this.$set(item, "options", this.getYearArray(item));
                this.$set(
                  this.selectVaueObj,
                  item.fieldName,
                  item.defaultValue
                );
              }
              if (item.defaultValue) {
                this.payInfo[item.fieldName] = item.defaultValue;
                this.$set(
                  this.selectVaueObj,
                  item.fieldName,
                  item.defaultValue
                );
              }
            });
          }
          resolve();
        });
      });
    },
    flattenTree(tree) {
      let result = []; // 存放最后的扁平化数组
      function traverseNode(node) {
        if (Array.isArray(node)) {
          node.forEach((child) => {
            traverseNode(child);
          });
        } else {
          result.push(node);

          if (node.children && Array.isArray(node.children)) {
            node.children.forEach((child) => {
              traverseNode(child);
            });
          }
        }
      }

      traverseNode(tree);

      return result;
    },

    // 打开下拉操作
    openPicker1(item) {
      // this.columns = item.options;
      this.showPicker1 = true;
      if (this.payInfo.itemId) {
        let tIdx = this.items.findIndex((val) => {
          return val.itemId == this.payInfo.itemId;
        });
        if (this.$refs.van_picker_item) {
          this.$nextTick(() => {
            this.$refs.van_picker_item.setIndexes([tIdx]);
          });
        }
      } else {
        if (this.$refs.van_picker_item) {
          this.$nextTick(() => {
            this.$refs.van_picker_item.setIndexes([0]);
          });
        }
      }
    },
    // 打开下拉操作
    openPicker(item) {
      this.columns = item.options;
      this.selectRow = item;
      if (this.payInfo[item.fieldName]) {
        this.defaultIndex = item.options.findIndex((val) => {
          return val.value == this.payInfo[item.fieldName];
        });
      } else {
        this.defaultIndex = 0;
      }
      this.showPicker = true;
      // 使用setIndexes方法设置选中项
      if (this.$refs.van_picker) {
        this.$nextTick(() => {
          this.$refs.van_picker[0].setIndexes([this.defaultIndex]);
        });
      }
    },
    confirmPicker(item) {
      this.payInfo[this.selectRow.fieldName] = item.value;
      this.selectVaueObj[this.selectRow.fieldName] = item.label;
      this.showPicker = false;
    },

    // 打开日期弹框
    openDate(item) {
      this.selectRow = item;
      this.showDate = true;
      if (item.allowFutureDate) {
        this.maxDateCom = this.maxNow;
      } else {
        this.maxDateCom = this.maxDate;
      }
      if (this.payInfo[item.fieldName]) {
        this.defaultDate = new Date(this.payInfo[item.fieldName]);
      } else {
        this.defaultDate = new Date();
      }
    },
    // 确认日期
    onConfirmDate(val) {
      this.payInfo[this.selectRow.fieldName] = formatterDate(val);
      this.selectVaueObj[this.selectRow.fieldName] = formatterDate(val);
      this.showDate = false;
    },
    // 打开日期时间
    openDateTime(item) {
      this.selectRow = item;
      this.showDateTimePicker = true;
      if (item.allowFutureDate) {
        this.maxDateCom = this.maxNow;
      } else {
        this.maxDateCom = this.maxDate;
      }
      if (this.payInfo[item.fieldName]) {
        this.currentDate = new Date(this.payInfo[item.fieldName]);
      } else {
        this.currentDate = new Date();
      }
    },
    // 确认日期时间
    onConfirmDateTime() {
      this.payInfo[this.selectRow.fieldName] = formatterSureDate(
        this.currentDate
      );
      this.selectVaueObj[this.selectRow.fieldName] = formatterSureDate(
        this.currentDate
      );
      this.showDateTimePicker = false;
    },
    // 确认收费项目
    confirmItem(value) {
      this.payInfo.itemId = value.itemId;
      this.payInfo.itemName = value.itemName;
      this.showPicker1 = false;
      this.payInfo.payAmt = value.amount ? String(value.amount) : "";
      this.editAmt = value.edit;
      if (this.payInfo.payAmt == "") {
        //返的金额为null时，不管edit为啥，都可编辑
        this.editAmt = true;
      }
    },
    // 打开软键盘
    openKeyBoard() {
      if (this.editAmt) {
        this.show = true;
      }
    },
    // 搜索条件处理----------------------------------------end

    // 上传文件操作---------------------start
    // 打开选择文件
    openFieldDialog(item) {
      this.showUploadDialog = true;
      this.selectRow = item;
    },
    //关闭上传文件弹窗
    closeUpload(info) {
      this.showUploadDialog = false;
      if (info.value.length > 0) {
        this.$set(
          this.uploadName,
          info.fieldName,
          "已上传" + info.value.length + "个文件"
        );
      }
      this.payInfo[info.fieldName] = JSON.stringify(info.value);
      let filedLists = JSON.parse(JSON.stringify(info.value));
      let arr = [];
      filedLists.forEach((item) => {
        let obj = {
          url: item.fileUrl,
          name: item.fileName,
        };
        arr.push(obj);
      });
      this.$set(this.uploadFiledsObj, info.fieldName, arr);
      console.log(
        "payInfo",
        this.payInfo,
        "uploadName",
        this.uploadName,
        "uploadFiledsObj",
        this.uploadFiledsObj
      );
    },
    // 上传文件操作---------------------end

    handleConfirm() {
      this.show = false;
      this.handlePay();
    },
    handlePay() {
      if (
        this.isRead == false &&
        (this.needTicketTip == "true" || this.needSyncField)
      ) {
        this.$router.push({
          path: "/parking/notice",
          query: {
            person: "1",
            headerText: "通知",
            params: JSON.stringify(this.$route.query),
          },
        });
        // this.$refs.privacyDialog.open();
        return;
      }

      if (this.isMust == true) {
        if (isEmpty(this.payInfo.paymentUnit)) {
          // Dialog.alert({
          //   title: "错误提示",
          //   message: "请填写缴款人",
          // }).then(() => {});
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: "请填写缴款人",
          }).then((res) => {});
          return;
        }
        if (isEmpty(this.payInfo.phone)) {
          // Dialog.alert({
          //   title: "错误提示",
          //   message: "请填写手机号码",
          // }).then(() => {});
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: "请填写手机号码",
          }).then((res) => {});
          return;
        }
      }
      let testPhone = /^1\d{10}$/;
      if (!testPhone.test(this.payInfo.phone) && !isEmpty(this.payInfo.phone)) {
        // Dialog.alert({
        //   title: "错误提示",
        //   message: "手机号码格式不正确",
        // }).then(() => {});
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "手机号码格式不正确",
        }).then((res) => {});
        return;
      }
      let bool = false;
      this.addData.find((item) => {
        if (item.nullable && isEmpty(this.payInfo[item.fieldName])) {
          // Dialog.alert({
          //   title: "错误提示",
          //   message: "请填写" + item.showName,
          // }).then(() => {});
          bool = true;
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message:
              item.fieldType == "2"
                ? "请选择" + item.showName
                : "请填写" + item.showName,
          }).then((res) => {});
        }
      });
      if (bool) return;

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      let second = 2;
      this.disabledBtn = true;
      const timer = setInterval(() => {
        second--;
        if (second) {
        } else {
          clearInterval(timer);
          Toast.clear();
        }
      }, 1000);

      if (window.localStorage.getItem("payRouteBack")) {
        window.localStorage.removeItem("payRouteBack");
      }
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/pay/payInitLbtc",
        method: "post",
        data: this.payInfo,
      }).then((res) => {
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else {
          Toast.clear();
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: res.data.message,
          }).then((res) => {
            this.disabledBtn = false;
          });
        }
      });
    },
    asyncLoadJs(url) {
      var Q = require("q");
      return Q.Promise((resolve, reject) => {
        let srcArr = document.getElementsByTagName("script");
        let hasLoaded = false;
        for (let i = 0; i < srcArr.length; i++) {
          //判断当前js是否加载上
          hasLoaded = srcArr[i].src == url ? true : false;
        }
        if (hasLoaded) {
          resolve();
          return;
        }
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject();
        };
      });
    },
    otherPay(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no,
      };
      // 微信小程序中，多加几个参数
      //   if (this.isWxmp) {
      //     this.$set(obj,'paymentName',res.paymentName)
      //     this.$set(obj,'itemNameSet',res.itemNameSet)
      //   }
      let that = this;
      console.log(1111);
      const interval = setInterval(() => {
        if (loadedMineMapJs) {
          this.disabledBtn = false;
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          // Toast.clear();
        }
      }, 100);
    },
  },
};
</script>

<style scoped lang='scss'>
// .parking {
//   position: relative;
//   // background: #fff;
//   min-height: 100vh;
//   .btn {
//     margin-top: 20px;
//   }
//   .bgBox {
//     min-height: 60vh;
//   }
//   .bgImg {
//     width: 100%;
//     margin-bottom: 100px;
//   }
//   .formBox {
//     width: 90%;
//     position: absolute;
//     left: 50%;
//     margin-left: -45%;
//     top: 60px;
//     margin-top: 60px;
//     > .formCont {
//       background-color: #fff;
//       box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
//       border-radius: 5px;
//       padding: 10px;
//       box-sizing: border-box;
//       margin-bottom: 30px;
//     }
//     // min-height: 40vh;
//     .van-button {
//       background: #0052ee;
//       border-radius: 5px;
//     }
//   }
// }
// .item {
//   border-bottom: 0.02667rem solid #eee;
//   height: 50px;
//   // padding-bottom: 10px;  70px
//   box-sizing: border-box;
//   line-height: 70px;
//   display: flex;
//   align-items: center;
//   padding-left: 15px;
//   justify-content: space-between;
//   padding-right: 15px;
//   span {
//     color: #333;
//     font-size: 0.4rem;
//     width: 80px;
//     white-space: nowrap;
//   }
//   input {
//     background: transparent;
//     font-size: 14px;
//     text-align: right;
//     width: 230px;
//   }
//   input::-webkit-input-placeholder {
//     font-size: 15px;
//     color: rgb(203, 201, 207);
//   }
//   input::-moz-placeholder {
//     /* Mozilla Firefox 19+ */
//     font-size: 15px;
//     color: rgb(203, 201, 207);
//   }
//   input:-moz-placeholder {
//     /* Mozilla Firefox 4 to 18 */
//     font-size: 15px;
//     color: rgb(203, 201, 207);
//   }
//   input:-ms-input-placeholder {
//     /* Internet Explorer 10-11 */
//     font-size: 15px;
//     color: rgb(203, 201, 207);
//   }
//   textarea {
//     width: 220px;
//     height: 70px;
//     line-height: 20px;
//     background: transparent;
//     margin-left: 20px;
//     font-size: 14px;
//     border: none;
//     position: relative;
//     top: 15px;
//     height: 49px;
//   }
// }
// .item1 {
//   height: 44px;
//   line-height: 44px;
//   padding-top: 10px;
// }
// .remark {
//   text-align: right;
//   font-size: 14px;
//   margin: 10px 0;
//   padding-right: 10px;
//   color: #50bfff;
// }
// .searchPicker {
//   >>> .van-cell {
//     border-bottom: 1px solid #eee;
//     height: 44px;
//     ::v-deep .van-cell__title {
//       font-size: 15px;
//       color: #2e3133;
//     }
//     ::v-deep .van-field__control {
//       font-size: 15px;
//       color: #2e3133;
//     }
//   }
// }
// .van-field {
//   border-bottom: 1px solid #eee;
//   height: 44px;
//   ::v-deep .van-cell__title {
//     font-size: 15px;
//     color: #2e3133;
//     white-space: nowrap;
//   }
//   ::v-deep .van-field__control {
//     font-size: 15px;
//     color: #2e3133;
//   }
// }
// .van-cell {
//   border-bottom: 1px solid #eee;
//   height: 44px;
//   ::v-deep .van-cell__title {
//     font-size: 15px;
//     color: #2e3133;
//   }
//   ::v-deep .van-field__control {
//     font-size: 15px;
//     color: #2e3133;
//   }
// }
// .footBox {
//   padding: 0 20px;
// }

.notice_box_foot {
  height: 46px;
  margin: 0 19px;
  color: #ffffff;
  font-weight: 700;

  font-size: 18px;
  line-height: 46px;
  letter-spacing: 0;
  text-align: center;
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border-radius: 22px;
}
.btn_shadow,
.notice_box_foot {
  position: relative;
  > span {
    position: absolute;
    bottom: -19px;
    left: 50%;
    z-index: 0;
    width: 90%;
    height: 0.96rem;
    margin-left: -45%;
    background: url("../../assets/other/blueshadow.png") 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 0.58667rem;
  }
}
#captcha {
  position: relative;
  right: 18px;
  width: 106px;
  height: 40px;
}
.mainbox {
  box-sizing: border-box;
  padding: 0 2vw;
  .van-form {
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
  }
  .van-cell {
    background: transparent;
  }
  .formTitle {
    padding-right: 40px;
    text-align-last: justify;
  }
  .code {
    overflow: hidden;
    white-space: nowrap;
    .van-cell {
      float: left;
      width: 60% !important;
    }
    img {
      float: right;
      width: 112px;
      height: 44px;
    }
  }
  .van-dialog__message {
    padding: 15px 10px !important;
    font-size: 15px !important;
  }
  .savePass {
    display: flex;
    align-items: center;
    margin: 12px 14px !important;
    > span {
      margin-right: 16px;
      color: #bfbfbf !important;
    }
    ::v-deep .van-checkbox__icon {
      height: 15px;
      line-height: 15px;
    }
    ::v-deep .van-checkbox__icon .van-icon {
      width: 15px;
      height: 15px;
      border: 1px solid #1989fa;
    }
    ::v-deep .van-checkbox__label {
      color: #1989fa;
    }
    ::v-deep .van-checkbox__icon--checked .van-icon {
      line-height: 15px;
    }
  }
  .btnBox {
    position: relative;
    .slideVerifyBox {
      position: absolute;
      bottom: -100px;
      left: 20px;
      z-index: 9999;
      background: #fff;
      box-shadow: 0 2px 12px 0 #666;
    }
  }
}

.white_bg {
  min-height: 100vh;
  background: #fff;
  ::v-deep .van-picker-column__item {
    color: rgba(70, 74, 76, 0.7);
    font-weight: 400;

    font-size: 18px;
    letter-spacing: 0;
  }
  ::v-deep .van-picker-column__item--selected {
    color: #464a4c;
    font-weight: 500;

    font-size: 20px;
    letter-spacing: 0;
  }
  ::v-deep .van-picker__cancel {
    color: #464a4c;
    font-weight: 500;

    font-size: 16px;
    letter-spacing: 0;
  }
  ::v-deep .van-picker__confirm {
    color: #208fff;
    font-weight: 500;

    font-size: 16px;
    letter-spacing: 0;
  }
}
.bindStudent {
  background: url("../../assets/img/backi.png") no-repeat;
  background-size: 100% 110%;
  .companyname {
    margin-bottom: 16px;
    padding-left: 26px;
    color: #ffffff;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 0;
    text-align: left;
  }
  .top {
    display: flex;
    align-items: flex-end;
    height: 200px;
    .boxd {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      margin-bottom: 20px;
      margin-left: 24px;
      background: #fff;
      border-radius: 40px;
      //todo logo
      > img {
        width: 79px;
      }
    }
    .rightLogo {
      display: block;
      width: 212px;
      height: 186px;
      margin: 0px auto;
    }
  }

  .center {
    margin-top: 10px;
    padding-top: 20px;
    background: url("../../assets/img/blcard.png") no-repeat;
    background-size: 100% 100%;
    .remarkBox {
      width: 325px;
      height: 212px;
      margin: 14px auto;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      .boxTop {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        padding-top: 0px;
        > img {
          width: 56px;
          height: 56px;
          margin-left: -10px;
        }
        .remkNotice {
          display: flex;
          justify-content: space-between;
          width: 255px;
          margin-bottom: 10px;
          margin-left: 15px;
          padding-right: 10px;
          color: #464a4c;
          font-weight: 500;

          font-size: 16px;
          letter-spacing: 0;
        }
      }
      .hr {
        width: 285px;
        height: 1px;
        margin: 0 auto;
        margin-top: -12px;
        padding-right: 10px;
        padding-left: 10px;
        background: #f0f0f0;
      }
      ::v-deep .van-field__control::-webkit-input-placeholder {
        color: rgba(70, 74, 76, 0.7);
        font-weight: 500;

        font-size: 16px;
        letter-spacing: 0;
      }
    }
    .fieldBox {
      ::v-deep input.van-field__control::-webkit-input-placeholder {
        color: rgba(70, 74, 76, 0.7);
        font-weight: 500;

        font-size: 16px;
        letter-spacing: 0;
      }
      ::v-deep .van-field__control {
        color: #464a4c;
        font-weight: 700;

        font-size: 16px;
        letter-spacing: 0;
      }
      display: flex;
      width: 325px;
      height: 44px;
      margin: 14px auto;
      background: #fff;
      border-radius: 25px;

      .wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 0px 20px;
        color: #464a4c;
        font-weight: 500;

        font-size: 16px;
        letter-spacing: 0;
      }
      .wrapF {
        width: 325px;
        height: 212px;
        background: #fff;
        .wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding: 0px 20px;
          color: #464a4c;
          font-weight: 500;

          font-size: 16px;
          letter-spacing: 0;
        }
      }
      img {
        width: 56px;
        height: 56px;
      }
      .self_qr_pic {
        width: 31.5px;
        height: 31.5px;
        margin: 6px 14px 0px 11px;
      }
      ::v-deep .van-field {
        width: 264px !important;
        padding-right: 8px;
        padding-left: 17px;
        border-radius: 25px;
      }

      .varify {
        width: 150px !important;
      }
      ::v-deep .van-cell {
        padding-left: 0px;
      }
      .getVari {
        margin-left: 30px;
        color: #208fff;
        font-weight: 500;

        font-size: 16px;
        line-height: 44px;
        letter-spacing: 0;
      }
    }
  }

  ::v-deep .footNotice {
    padding: 0px 20px;
  }

  ::v-deep .foot {
    margin-bottom: 0px !important;
  }
}
.rem_class {
  margin-bottom: 26px;
  padding-left: 24px;
  ::v-deep .van-checkbox__icon .van-icon {
    width: 16px;
    height: 16px;
    line-height: 14px;
    border-color: #208fff;
  }
  ::v-deep .van-checkbox__icon {
    width: 16px;
    height: 16px;
  }
  ::v-deep .van-icon-success::before {
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    padding-right: 2px;
    font-size: 14px;
    line-height: 1;
  }
  ::v-deep .van-checkbox__label {
    color: #464a4c;
    font-weight: 400;

    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0;
  }
}
.bindBtn {
  position: relative;
  width: 326px;
  height: 50px;
  margin: 0 auto;
  margin-top: 20px;
  color: #fff;

  color: #ffffff;
  font-weight: 700;
  font-weight: 700;
  font-size: 20px;
  letter-spacing: 0;
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border: none !important;
  border-radius: 27px;
  outline: none !important;
  ::v-deep .van-button::before {
    border: none;
  }
  .blueSha {
    position: absolute;
    top: 68%;
    left: 50%;
    width: 296px;
    height: 34px;
    transform: translateX(-50%);
  }
  // box-shadow: 0px 6px 2px #208FFF;
}

.pri {
  // margin:0 auto;
  // text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -16px;
  // padding-left: 12px;
  span:nth-of-type(1) {
    color: #464a4c;
    font-weight: 400;

    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0;
  }
  span:nth-of-type(2) {
    color: #208fff;
    font-weight: 700;

    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0;
  }
  ::v-deep .van-checkbox__icon .van-icon {
    border-color: #208fff;
    border-radius: 4px;
  }
}
.noReg {
  margin-top: 23px;
  color: #464a4c;
  font-weight: 400;

  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0;
  text-align: center;
  > span {
    color: #208fff;
    font-weight: 700;

    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0;
  }
}
.zdyfooter {
  margin-top: 30px !important;
  padding: 0px 28px;
}
.notice_foot {
  height: 46px;
  margin: 0 19px;
  color: #ffffff;
  font-weight: 700;

  font-size: 18px;
  line-height: 46px;
  letter-spacing: 0;
  text-align: center;
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border-radius: 22px;
}
.btn_shadow,
.notice_box_foot {
  position: relative;
  > span {
    position: absolute;
    bottom: -19px;
    left: 50%;
    z-index: 0;
    width: 90%;
    height: 0.96rem;
    margin-left: -45%;
    background: url("../../assets/img/blueshadow.png") 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 0.58667rem;
  }
}
</style>
